import React, { createContext, useContext, useState, useCallback } from 'react'
import { AuthContext } from "./AuthContext";
import axios from "axios";
import baseurl from "../services/empresa/baseurl";
import Cookies from 'js-cookie'
import { ApiContext } from './ApiContext';

export const PermissoesContext = createContext()

export const PermissoesContextProvider = ({ children }) => {

    const { setAuth, EmpresaKey } = useContext(AuthContext)
    const [Error, setError] = useState("")
    const [Success, setSuccess] = useState("")
    const [loading, setLoading] = useState(false)
    const [MenuAdicionarEmLote, setMenuAdicionarEmLote] = useState([])
    const [MenuAlterarEmLote, setMenuAlterarEmLote] = useState([])
    const [ObterMenu, setObterMenu] = useState([])
    const [Menu, setMenu] = useState([])
    const [MenuUsuario, setMenuUsuario] = useState([])

    const AdicionarEmLote = async () => {
        setLoading(true)
        const token = Cookies.get("Token");
        let dados = [
            {
                usuarioId: MenuAdicionarEmLote.usuarioId,
                menuKey: MenuAdicionarEmLote.menuKey,
                edicao: MenuAdicionarEmLote.edicao,
                somenteLeitura: MenuAdicionarEmLote.somenteLeitura,
                empresaKey: EmpresaKey
                
            }
        ];
        return axios({
            url: baseurl + "Permissoes/AdicionarEmLote",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: dados,
        })
            .then(() => {
                setLoading(false)
                setSuccess("Adicionado com sucesso!");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                console.log(error)
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    }

    const AlterarEmLote = async () => {
        setLoading(true)
        const token = Cookies.get("Token");
        let dados = [
            {
                usuarioId: MenuAlterarEmLote.usuarioId,
                menuKey: MenuAlterarEmLote.menuKey,
                edicao: MenuAlterarEmLote.edicao,
                somenteLeitura: MenuAlterarEmLote.somenteLeitura,
                empresaKey: EmpresaKey
            }
        ];
        return axios({
            url: baseurl + "Permissoes/AlterarEmLote",
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            data: dados,
        })
            .then(() => {
                setLoading(false)
                setSuccess("Alterado com sucesso!");
                setTimeout(() => {
                    setSuccess("");
                }, 3000);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false)
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setAuth(false)
                    return
                }
                error.response.data.map((er) => {
                    setError(`${er.campo}: ${er.mensagem}`)
                })
                console.log(error)
                setTimeout(() => {
                    setError("");
                }, 3000);
                return Promise.reject();
            });
    }

    const ObterKeyMenu = useCallback(async (key) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Permissoes/ObterKey?key=" + key,
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setObterMenu(response.data);
                return Promise.resolve()
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                console.log(error)
                return Promise.reject()
            })
    })

    const ListarMenu = useCallback(async () => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Permissoes/ListarMenu",
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setMenu(response.data)
                return Promise.resolve()
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                return Promise.reject()
            })
    })

    const ListarMenuUsuario = useCallback(async (usuarioId) => {
        const token = Cookies.get("Token");
        return axios({
            url: baseurl + "Permissoes/Listar?UsuarioId=" + usuarioId + "&empresaKey=" + EmpresaKey,
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((response) => {
                setMenuUsuario(response.data);
                return Promise.resolve()
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    setError(`Sua sessão expirou, faça login novamente`)
                    setTimeout(() => {
                        setError("");
                    }, 3000);
                    setLoading(false);
                    setAuth(false)
                    return
                }
                console.log(error)
                return Promise.reject()
            })
    })

    const data = {
        Success, Error, loading, setLoading,
        AdicionarEmLote, MenuAdicionarEmLote, setMenuAdicionarEmLote,
        AlterarEmLote, MenuAlterarEmLote, setMenuAlterarEmLote,
        ObterKeyMenu, ObterMenu,
        ListarMenu, Menu,
        ListarMenuUsuario, MenuUsuario
    }

    return (
        <PermissoesContext.Provider value={data}>
            {children}
        </PermissoesContext.Provider>
    )
}